import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import {store} from './app/store/store'
import money from 'v-money'
import TheMask from 'vue-the-mask'

//Vue.forceUpdate();

// register directive v-money and component <money>
Vue.use(money, {precision: 2})
Vue.config.productionTip = false;
Vue.use(TheMask)

/**
 * Globais
 */
Vue.prototype.$globalformmasks = {  cpf:'###.###.###-##', 
                              cnpj:'##.###.###/####-##',
                              cellphone: '(##) #-####-####',
                              phone: '(##) ####-####'
                            };
Vue.prototype.$creditStatus = {'not_payed':{s:'NÃO PAGO'},'payed':{s:'PAGO'},'cancelled':{s:'CANCELADO'},'waiting_payment':{s:'AGUARDANDO PAGAMENTO'}};

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')
